const DealsData = [
    {
        offText: "10% Off",
        rdpName: "99RDP",
        cardTitle: "99RDP Flash Deal - 10% Off Premium Windows Server Plans",
        verifyText: "Verified Today",
        usesText: "42 Uses Today",
        BoxDesc: "Lightning-fast deployment with 99RDP's optimized infrastructure. Get SSD-powered servers with 99.9% uptime guarantee and free migration assistance.",
        btnLink: "https://99rdp.com/",
        modalDesc: "Apply this exclusive code at checkout:",
        modalCode: "FLASH99RDP"
    },
    {
        offText: "10% Off",
        rdpName: "99RDP",
        cardTitle: "99RDP Weekend Special - 10% Off All Shared RDP Plans",
        verifyText: "Verified Today",
        usesText: "31 Uses Today",
        BoxDesc: "Weekend savings on 99RDP's cost-effective shared hosting. Perfect for freelancers and small projects with reliable performance and full admin access.",
        btnLink: "https://99rdp.com/",
        modalDesc: "Copy and apply this code:",
        modalCode: "WEEKEND99"
    },
    {
        offText: "10% Off",
        rdpName: "buyrdplive.com",
        cardTitle: "buyrdplive.com Special - Save 10% on Multi-User RDP Packages",
        verifyText: "Verified Today",
        usesText: "36 Uses Today",
        BoxDesc: "Scale your team with buyrdplive.com's collaborative RDP solutions. Features include priority support, automatic backups, and flexible user management.",
        btnLink: "https://www.buyrdplive.com/",
        modalDesc: "Enter this discount code at checkout:",
        modalCode: "LIVETEAM10"
    },
    {
        offText: "10% Off",
        rdpName: "buyrdplive.com",
        cardTitle: "buyrdplive.com Upgrade Offer - 10% Off When You Switch",
        verifyText: "Verified Today",
        usesText: "27 Uses Today",
        BoxDesc: "Switching providers? buyrdplive.com makes it easy with free data transfer, setup assistance, and this exclusive 10% welcome discount.",
        btnLink: "https://www.buyrdplive.com/",
        modalDesc: "Use this switcher code at checkout:",
        modalCode: "SWITCH2LIVE"
    },
    {
        offText: "10% Off",
        rdpName: "PCRDP",
        cardTitle: "PCRDP Enterprise Sale - 10% Discount on Business Solutions",
        verifyText: "Verified Today",
        usesText: "39 Uses Today",
        BoxDesc: "Power your business with PCRDP's enterprise-grade infrastructure. Includes DDoS protection, custom configurations, and 24/7 technical assistance.",
        btnLink: "https://pcrdp.com/",
        modalDesc: "Use this code to claim your savings:",
        modalCode: "PCBIZ10"
    },
    {
        offText: "10% Off",
        rdpName: "PCRDP",
        cardTitle: "PCRDP Developer Edition - 10% Off Coding-Optimized RDP",
        verifyText: "Verified Today",
        usesText: "33 Uses Today",
        BoxDesc: "Tailored for developers: PCRDP servers with pre-installed IDEs, Git integration, and high-performance specs. Save 10% on your development environment.",
        btnLink: "https://pcrdp.com/",
        modalDesc: "Apply developer discount code:",
        modalCode: "DEVPC10"
    },
    {
        offText: "10% Off",
        rdpName: "AmazingRDP",
        cardTitle: "AmazingRDP Performance Pro - 10% Off High-Speed RDP Plans",
        verifyText: "Verified Today",
        usesText: "38 Uses Today",
        BoxDesc: "Boost productivity with AmazingRDP's high-performance RDPs optimized for trading, designing, and multitasking. Experience dedicated speed and stability with NVMe power.",
        btnLink: "https://amazingrdp.com/",
        modalDesc: "Unlock performance savings with code:",
        modalCode: "PRO10OFF"
    },
    {
        offText: "10% Off",
        rdpName: "AmazingRDP",
        cardTitle: "AmazingRDP Starter Pack - Get 10% Off Your First Order",
        verifyText: "Verified Today",
        usesText: "44 Uses Today",
        BoxDesc: "Begin your remote desktop journey with AmazingRDP's newcomer discount. Instant activation, pre-installed software, and expert onboarding included.",
        btnLink: "https://amazingrdp.com/",
        modalDesc: "Redeem this code during checkout:",
        modalCode: "NEWSTART10"
    },




    {
        offText: "10% Off",
        rdpName: "PCRDP",
        cardTitle: "PCRDP Premium RDP Services - Professional Cloud Hosting 10% Off",
        verifyText: "Verified Yesterday",
        usesText: "32 Uses Today",
        BoxDesc: "Get PCRDP business RDP with high-speed connectivity, dedicated servers, and secure remote access. Affordable plans make it one of the best RDP in Pakistan.",
        btnLink: "https://pcrdp.com/",
        modalDesc: "Apply this code at checkout:",
        modalCode: "PCRDP10SAVE"
    },
    {
        offText: "10% Off",
        rdpName: "buyrdplive.com",
        cardTitle: "BuyRDPLive Premium Services - High-Performance RDP with 24/7 Support 10% Off",
        verifyText: "Verified Yesterday",
        usesText: "28 Uses Today",
        BoxDesc: "Enjoy buyrdplive.com hosting with instant setup and SSD servers. Secure connections for gaming, streaming, and fast RDP with JazzCash payment support.",
        btnLink: "https://www.buyrdplive.com/",
        modalDesc: "Use this code at checkout:",
        modalCode: "LIVE10OFF"
    },
    {
        offText: "10% Off",
        rdpName: "99RDP",
        cardTitle: "99RDP Hosting Plans - Smooth RDP Experience with Global Locations 10% Off",
        verifyText: "Verified Yesterday",
        usesText: "48 Uses Today",
        BoxDesc: "99RDP offers VPS hosting with unlimited bandwidth, Windows 11 support, and secure resources. Known for cheap RDP price in Pakistan with strong performance.",
        btnLink: "https://99rdp.com/",
        modalDesc: "Use this code during checkout on 99RDP:",
        modalCode: "99RDP10"
    },
    {
        offText: "10% Off",
        rdpName: "AmazingRDP",
        cardTitle: "Amazing RDP Fast Solutions - Secure Remote Desktop Hosting 10% Off",
        verifyText: "Verified Yesterday",
        usesText: "34 Uses Today",
        BoxDesc: "AmazingRDP provides SSL-secured cloud servers with enterprise hosting. A trusted choice for dedicated RDP and performance-focused users.",
        btnLink: "https://amazingrdp.com/",
        modalDesc: "Apply this code during checkout:",
        modalCode: "AMAZING10"
    },
    {
        offText: "10% Off",
        rdpName: "EurRDP",
        cardTitle: "EurRDP European Hosting - GDPR Compliant EU Servers 10% Off",
        verifyText: "Verified Yesterday",
        usesText: "29 Uses Today",
        BoxDesc: "EurRDP offers low-latency Germany, Netherlands, and UK servers. GDPR compliant, fast RDP solutions with multilingual support for global users.",
        btnLink: "https://eurrdp.com/",
        modalDesc: "Use this code at checkout:",
        modalCode: "EURRDP10"
    },
    {
        offText: "10% Off",
        rdpName: "HomeRDP",
        cardTitle: "HomeRDP Personal Use - Reliable Remote Work Solutions 10% Off",
        verifyText: "Verified Yesterday",
        usesText: "20 Uses Today",
        BoxDesc: "HomeRDP is perfect for home office and remote work. Affordable and easy setup makes it one of the cheapest RDP in Pakistan.",
        btnLink: "https://homerdp.com/",
        modalDesc: "Paste this code during checkout:",
        modalCode: "HOMERDP10"
    },
    {
        offText: "10% Off",
        rdpName: "GORDP",
        cardTitle: "GORDP Global Hosting - High-Performance VPS Worldwide 10% Off",
        verifyText: "Verified Yesterday",
        usesText: "18 Uses Today",
        BoxDesc: "GORDP delivers enterprise-grade VPS with global servers. Recognized among RDP Wale providers for secure, scalable hosting worldwide.",
        btnLink: "https://gordp.com/",
        modalDesc: "Enter this on GORDP checkout:",
        modalCode: "GORDP10"
    },
    {
        offText: "10% Off",
        rdpName: "RDPDatabase",
        cardTitle: "RDPDatabase Secure Hosting - Enterprise RDP with Managed Services 10% Off",
        verifyText: "Verified Yesterday",
        usesText: "15 Uses Today",
        BoxDesc: "RDPDatabase provides cloud servers with backup and monitoring. Popular for managed services, trusted like Sandeep RDP in enterprise setups.",
        btnLink: "https://rdpdatabase.com/",
        modalDesc: "Use this code on checkout page:",
        modalCode: "RDPDATABASE10"
    },




    {
        offText: "10% Off",
        rdpName: "PCRDP",
        cardTitle: "Save 10% on PCRDP Premium RDP Services",
        verifyText: "Verified Yesterday",
        usesText: "32 Uses Today",
        BoxDesc: "Professional cloud RDP solutions with 10% savings. Perfect for business and personal use.",
        btnLink: "https://pcrdp.com/",
        modalDesc: "Apply this code at checkout:",
        modalCode: "PCRDP10SAVE",
    },
    {
        offText: "20% Off",
        rdpName: "PCRDP",
        cardTitle: "Exclusive 20% Discount on PCRDP Hosting Plans",
        verifyText: "Verified Yesterday",
        usesText: "45 Uses Today",
        BoxDesc: "Get premium RDP hosting with enhanced security and performance. Save 20% on all plans.",
        btnLink: "https://pcrdp.com/",
        modalDesc: "Enter this code during checkout:",
        modalCode: "PCRDP20DEAL",
    },
    {
        offText: "10% Off",
        rdpName: "buyrdplive.com",
        cardTitle: "buyrdplive.com Offers 10% Off on All RDP Plans",
        verifyText: "Verified Yesterday",
        usesText: "28 Uses Today",
        BoxDesc: "Reliable RDP services with 24/7 support. Get 10% off your first purchase today.",
        btnLink: "https://www.buyrdplive.com/",
        modalDesc: "Use this code at checkout:",
        modalCode: "LIVE10OFF",
    },
    {
        offText: "20% Off",
        rdpName: "buyrdplive.com",
        cardTitle: "Big Savings: 20% Off buyrdplive.com Premium Services",
        verifyText: "Verified Yesterday",
        usesText: "38 Uses Today",
        BoxDesc: "Experience high-performance RDP with instant setup. Limited time 20% discount available.",
        btnLink: "https://www.buyrdplive.com/",
        modalDesc: "Paste this code during checkout:",
        modalCode: "LIVE20SAVE",
    },
    {
        offText: "25% Off",
        rdpName: "99RDP",
        cardTitle: "Enjoy 25% Off on All 99RDP Plans",
        verifyText: "Verified Yesterday",
        usesText: "48 Uses Today",
        BoxDesc: "Enjoy a smooth RDP experience with 25% off on all 99RDP plans.",
        btnLink: "https://99rdp.com/",
        modalDesc: "Use this code during checkout on 99RDP:",
        modalCode: "99RDP25",
    },
    {
        offText: "25% Off",
        rdpName: "99RDP",
        cardTitle: "Exclusive 25% Discount on 99RDP Hosting",
        verifyText: "Verified Yesterday",
        usesText: "42 Uses Today",
        BoxDesc: "Limited time offer: 25% discount on all VPS servers from 99RDP.",
        btnLink: "https://99rdp.com/",
        modalDesc: "Apply this code at checkout:",
        modalCode: "99RDP2025",
    },
    {
        offText: "25% Off",
        rdpName: "Amazaing",
        cardTitle: "Save 25% on All Amazaing RDP Plans",
        verifyText: "Verified Yesterday",
        usesText: "34 Uses Today",
        BoxDesc: "Get 25% off fast and secure remote desktop hosting with Amazaing.",
        btnLink: "https://amazingrdp.com/",
        modalDesc: "Apply this code during checkout:",
        modalCode: "AMAZAING25",
    },
    {
        offText: "25% Off",
        rdpName: "Amazaing",
        cardTitle: "Big Savings on 2025 Amazaing RDP Deals",
        verifyText: "Verified Yesterday",
        usesText: "27 Uses Today",
        BoxDesc: "Save big in 2025 with 25% off Amazaing RDP plans.",
        btnLink: "https://amazingrdp.com/",
        modalDesc: "Paste this code at checkout:",
        modalCode: "AMAZAING2025",
    },
    {
        offText: "25% Off",
        rdpName: "EurRDP",
        cardTitle: "25% Discount on EurRDP Hosting Services",
        verifyText: "Verified Yesterday",
        usesText: "29 Uses Today",
        BoxDesc: "EurRDP now offers 25% off for all EU-based remote desktop services.",
        btnLink: "https://eurdp.com/",
        modalDesc: "Use this code at checkout:",
        modalCode: "EURRDP25",
    },
    {
        offText: "25% Off",
        rdpName: "EurRDP",
        cardTitle: "Save 25% on EurRDP Plans This 2025",
        verifyText: "Verified Yesterday",
        usesText: "23 Uses Today",
        BoxDesc: "Start 2025 with savings — 25% off on all EurRDP plans.",
        btnLink: "https://eurdp.com/",
        modalDesc: "Enter this code at checkout:",
        modalCode: "EURRDP2025",
    },
    {
        offText: "25% Off",
        rdpName: "HomeRDP",
        cardTitle: "Get Reliable HomeRDP at 25% Off",
        verifyText: "Verified Yesterday",
        usesText: "20 Uses Today",
        BoxDesc: "Reliable home RDP at 25% off – perfect for personal or remote work.",
        btnLink: "https://homerdp.com/",
        modalDesc: "Paste this code during checkout:",
        modalCode: "HOMERDP25",
    },
    {
        offText: "25% Off",
        rdpName: "HomeRDP",
        cardTitle: "HomeRDP Plans Now 25% Off in 2025",
        verifyText: "Verified Yesterday",
        usesText: "18 Uses Today",
        BoxDesc: "HOMERDP’s 2025 deal — 25% off your first subscription.",
        btnLink: "https://homerdp.com/",
        modalDesc: "Apply this code at checkout:",
        modalCode: "HOMERDP2025",
    },
    {
        offText: "25% Off",
        rdpName: "GORDP",
        cardTitle: "Get 25% Discount on GORDP Hosting Plans",
        verifyText: "Verified Yesterday",
        usesText: "18 Uses Today",
        BoxDesc: "Save 25% on global high-performance VPS with GORDP.",
        btnLink: "https://gordp.com/",
        modalDesc: "Enter this on GORDP checkout:",
        modalCode: "GORDP25",
    },
    {
        offText: "25% Off",
        rdpName: "GORDP",
        cardTitle: "GORDP Deals for 2025 — Save 25% Instantly",
        verifyText: "Verified Yesterday",
        usesText: "15 Uses Today",
        BoxDesc: "GORDP2025 deal is live – 25% off for early subscribers.",
        btnLink: "https://gordp.com/",
        modalDesc: "Paste this during checkout:",
        modalCode: "GORDP2025",
    },
    {
        offText: "25% Off",
        rdpName: "RDPDatabase",
        cardTitle: "RDPDatabase Offers 25% Discount on All Plans",
        verifyText: "Verified Yesterday",
        usesText: "15 Uses Today",
        BoxDesc: "Big savings on RDPDatabase — get 25% off today!",
        btnLink: "https://rdpdatabase.com/",
        modalDesc: "Use this code on checkout page:",
        modalCode: "RDPDATABASE25",
    },
    {
        offText: "25% Off",
        rdpName: "RDPDatabase",
        cardTitle: "Kickstart 2025 with RDPDatabase Discounts",
        verifyText: "Verified Yesterday",
        usesText: "12 Uses Today",
        BoxDesc: "Start your 2025 strong with 25% off RDPDatabase.",
        btnLink: "https://rdpdatabase.com/",
        modalDesc: "Enter this during checkout:",
        modalCode: "RDPDATABASE2025",
    },
    {
        offText: "25% Off",
        rdpName: "PCRDP",
        cardTitle: "Get 25% Off on PCRDP Services Today",
        verifyText: "Verified Yesterday",
        usesText: "12 Uses Today",
        BoxDesc: "Professional-grade cloud RDP now 25% cheaper with PCRDP25.",
        btnLink: "https://pcrdp.com/",
        modalDesc: "Paste this during checkout:",
        modalCode: "PCRDP25",
    },
    {
        offText: "25% Off",
        rdpName: "PCRDP",
        cardTitle: "Save 25% on PCRDP Hosting This 2025",
        verifyText: "Verified Yesterday",
        usesText: "9 Uses Today",
        BoxDesc: "New year, new deal — get 25% off with PCRDP2025.",
        btnLink: "https://pcrdp.com/",
        modalDesc: "Use this code at checkout:",
        modalCode: "PCRDP2025",
    },
    {
        offText: "50% Off",
        rdpName: "99RDP",
        cardTitle: "Massive Black Friday Deal – 50% Off on VPS Servers!",
        verifyText: "Verified Yesterday",
        usesText: "61 Uses Today",
        BoxDesc: "Get high-performance VPS servers at half the price. Hurry, offer ends soon!",
        btnLink: "https://99rdp.com/black-friday-sale/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "99VPS50BF",
    },
    {
        offText: "50% Off",
        rdpName: "AmazingRDP",
        cardTitle: "Half-Price VPS Servers – AmazaingRDP Black Friday Deal!",
        verifyText: "Verified Yesterday",
        usesText: "61 Uses Today",
        BoxDesc: "Run your projects at lightning speed with VPS servers, now 50% off!",
        btnLink: "https://amazingrdp.com/friday-sale/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "AMAZINGVPS50",
    },
    {
        offText: "50% Off",
        rdpName: "HomeRDP",
        cardTitle: "HomeRDP Black Friday Offer – 50% Off VPS Servers!",
        verifyText: "Verified Yesterday",
        usesText: "61 Uses Today",
        BoxDesc: "Get power-packed VPS servers at 50% off. Grab this limited-time offer now!",
        btnLink: "https://homerdp.com/black-friday-offers/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "HOMEVPS50",
    },
    {
        offText: "50% Off",
        rdpName: "GPURDP",
        cardTitle: "Unbeatable Black Friday Deal – 50% Off VPS Servers!",
        verifyText: "Verified Yesterday",
        usesText: "61 Uses Today",
        BoxDesc: "Supercharge your performance with GPU-enabled VPS servers at 50% off. Limited-time offer!",
        btnLink: "https://gpurdp.com/black-friday-sale/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "GPUVPS50",
    },
    {
        offText: "20% Off",
        rdpName: "99RDP",
        cardTitle: "20% Off on 99RDP Dedicated Servers – Black Friday Exclusive!",
        verifyText: "Verified Yesterday",
        usesText: "61 Uses Today",
        BoxDesc: "Upgrade to premium dedicated servers at 20% off. Offer valid during Black Friday only!",
        btnLink: "https://99rdp.com/black-friday-sale/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "99DED20BF",
    },
    {
        offText: "20% Off",
        rdpName: "AmazingRDP",
        cardTitle: "AmazaingRDP Black Friday – 20% Off Dedicated Servers!",
        verifyText: "Verified Yesterday",
        usesText: "61 Uses Today",
        BoxDesc: "Reliable, fast, and now 20% cheaper! Grab this deal on dedicated servers today.",
        btnLink: "https://amazingrdp.com/friday-sale/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "AMAZINGDED20",
    },
    {
        offText: "20% Off",
        rdpName: "HomeRDP",
        cardTitle: "Black Friday Deal – 20% Off Dedicated Servers at HomeRDP!",
        verifyText: "Verified Yesterday",
        usesText: "61 Uses Today",
        BoxDesc: "Save big this Black Friday with 20% off on our dedicated servers. Your perfect hosting solution awaits!",
        btnLink: "https://homerdp.com/black-friday-offers/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "HOMED20BF",
    },
    {
        offText: "20% Off",
        rdpName: "GPURDP",
        cardTitle: "20% Off GPU-Enhanced Dedicated Servers – Black Friday!",
        verifyText: "Verified Yesterday",
        usesText: "61 Uses Today",
        BoxDesc: "Optimize your workloads with GPU-enabled dedicated servers, now at 20% off for Black Friday.",
        btnLink: "https://gpurdp.com/black-friday-sale/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "GPUEDED20",
    },
    {
        offText: "10% Off",
        rdpName: "99RDP",
        cardTitle: "Save 10% on Every Renewal – Exclusive for Black Friday!",
        verifyText: "Verified Yesterday",
        usesText: "61 Uses Today",
        BoxDesc: "Enjoy consistent savings with 10% off every renewal. Keep your servers running without breaking the bank!",
        btnLink: "https://99rdp.com/black-friday-sale/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "99RENEW10",
    },
    {
        offText: "10% Off",
        rdpName: "AmazingRDP",
        cardTitle: "Renew and Save – Black Friday 10% Off!",
        verifyText: "Verified Yesterday",
        usesText: "61 Uses Today",
        BoxDesc: "Lock in savings with 10% off every renewal. Don’t miss this exclusive Black Friday offer.",
        btnLink: "https://amazingrdp.com/friday-sale/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "AMAZINGRENEW10",
    },
    {
        offText: "10% Off",
        rdpName: "HomeRDP",
        cardTitle: "HomeRDP Renewal Discount – Save 10% on Every Renew!",
        verifyText: "Verified Yesterday",
        usesText: "61 Uses Today",
        BoxDesc: "Keep your hosting costs low with a 10% discount on renewals. Offer valid for Black Friday.",
        btnLink: "https://homerdp.com/black-friday-offers/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "HOMERENEW10",
    },
    {
        offText: "10% Off",
        rdpName: "GPURDP",
        cardTitle: "Black Friday Savings – 10% Off on Renewals!",
        verifyText: "Verified Yesterday",
        usesText: "61 Uses Today",
        BoxDesc: "Enjoy uninterrupted service with 10% off every renewal. Exclusive to Black Friday shoppers!",
        btnLink: "https://gpurdp.com/black-friday-sale/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "GPURENEW10",
    },
    {
        offText: "10% Off",
        rdpName: "99RDP",
        cardTitle: "Now Get 10% off on All Plans.",
        verifyText: "Verified Yesterday",
        usesText: "61 Uses Today",
        BoxDesc: "Avail this offer and save big bucks on your reliable and cost-effective RDP services.",
        btnLink: "https://99rdp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "R6D6P6",
    },
    {
        offText: "15% Off",
        rdpName: "AmazingRDP",
        cardTitle: "AMD Beast Dedicated RDP $15 Off",
        verifyText: "Verified 1 Day Ago",
        usesText: "61 Uses Today",
        BoxDesc: "32-Core 64-T @3 GHz 128 GB DDR4 ECC RAM 1 Gbps Private Port 4 TB NVMe SSD Disk Unlimited Bandwidth Windows Server 2019 Location of Germany/Finland",
        btnLink: "https://amazingrdp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "A6R6D6P6",
    },
    {
        offText: "5% Off",
        rdpName: "GPURDP",
        cardTitle: "Affordable GPU Shared RDP $5 off",
        verifyText: "Verified 3 Days Ago",
        usesText: "7 Uses Today",
        BoxDesc: "Want To Run Emulators? Want To Do Graphics Intensive Work? No Worries We Got It Covered For You.",
        btnLink: "https://gpurdp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "Renewal5",
    },
    {
        offText: "10% Off",
        rdpName: "EURRDP",
        cardTitle: "Now Get 10% Off on All Monthly Plans.",
        verifyText: "Verified 31 days ago",
        usesText: "3 Uses Today",
        BoxDesc: "Get an all-round year of quality RDP services at a whopping 10% off",
        btnLink: "https://eurdp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "AmazingR5",
    },
    {
        offText: "15% Off",
        rdpName: "99Server",
        cardTitle: "Now Get 15% Off on Mexico Dedicated Server.",
        verifyText: "Verified 11 Days Ago",
        usesText: "34 Uses Today",
        BoxDesc: "Get an all-round year of quality RDP services at a whopping 15% off",
        btnLink: "https://99server.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "Renewal5",
    },
    {
        offText: "5% Off",
        rdpName: "99RDP",
        cardTitle: "Get 5% Off Each Time On Every Renewal.",
        verifyText: "Verified 2 Days Ago",
        usesText: "30 Uses Today",
        BoxDesc: "Quam euismod elementum adipiscing mauris amet in tellus. Turpis enim id varius tincidunt.",
        btnLink: "https://99rdp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "AmazDGgR5",
    },
    {
        offText: "5% Off",
        rdpName: "GoRDP",
        cardTitle: "Now Get 5% Off On All New purchases.",
        verifyText: "Verified 4 Days Ago",
        usesText: "20 Uses Today",
        BoxDesc: "Struggling to find new RDP services? Well, GoRDP is set to offer you all the amazing perks alongside a 5% off on every new purchase.",
        btnLink: "https://gordp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "R6DTG6P6",
    },
    {
        offText: "10% Off",
        rdpName: "AmazingRDP",
        cardTitle: "Powerful GPU Dedicated Server. $10 off",
        verifyText: "Verified 8 Days Ago",
        usesText: "9 Uses Today",
        BoxDesc: "Powerful GPU Dedicated Server with GeForce® GTX 1080 configured so that you can run android emulators and online games smoothly.Get It At Just $159/m After Applying Coupon Code NVIDIA$10",
        btnLink: "https://gpurdp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "RenAASwal5",
    },
    {
        offText: "10% Off",
        rdpName: "RDP Database",
        cardTitle: "Now Get 10% Off on All Monthly Plans.",
        verifyText: "Verified 31 Days Ago",
        usesText: "70 Uses Today",
        BoxDesc: "Tempus tincidunt senectus lacinia pulvinar vitae fermentum vel digni risus. Cursus malesuada.",
        btnLink: "https://rdpdatabase.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "AmaengR5",
    },
    {
        offText: "15% Off",
        rdpName: "AmazingRDP",
        cardTitle: "15% Off on Residential RDP",
        verifyText: "Verified 2 Days Ago",
        usesText: "21 Uses Today",
        BoxDesc: "Did you expect RDP renewal at such decent rates? Instantly use this code for a 5% off on renewal.",
        btnLink: "https://amazingrdp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "AmDUTSR5",
    },
    {
        offText: "5% Off",
        rdpName: "GoRDP",
        cardTitle: "Affordable GPU Shared RDP $5 off",
        verifyText: "Verified 8 Days Ago",
        usesText: "7 Uses Today",
        BoxDesc: "Want To Run Emulators? Want To Do Graphics Intensive Work? No Worries We Got It Covered For You.",
        btnLink: "https://gordp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "AmDUTS765",
    },
    {
        offText: "10% Off",
        rdpName: "99RDP",
        cardTitle: "Get 10% Off On the Streaming Plan.",
        verifyText: "Verified 4 Days Ago",
        usesText: "300 Uses Today",
        BoxDesc: "To get great speed and guaranteed quality services, get streaming plans from 99RDP at 10% off.",
        btnLink: "https://99rdp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "EDIFS765",
    },
    {
        offText: "25% Off",
        rdpName: "AmazingRDP",
        cardTitle: "Get 25% instant off on all plans",
        verifyText: "Verified 5 Days Ago",
        usesText: "20 Uses Today",
        BoxDesc: "Sale is Again Here Buy Any RDP Plan From Us & Get 25% Off Instantly Hurry!! Get The Benefits While This Sale Lasts",
        btnLink: "https://amazingrdp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "AKYsj5",
    },
    {
        offText: "5% Off",
        rdpName: "GPURDP",
        cardTitle: "Affordable GPU Shared RDP $5 off",
        verifyText: "Verified 8 Days Ago",
        usesText: "7 Uses Today",
        BoxDesc: "Want To Run Emulators? Want To Do Graphics Intensive Work? No Worries We Got It Covered For You.",
        btnLink: "https://gpurdp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "KYGst93",
    },
    {
        offText: "5% Off",
        rdpName: "99RDP",
        cardTitle: "Now Get 5% Off On All New purchases.",
        verifyText: "Verified 4 Days Ago",
        usesText: "20 Uses Today",
        BoxDesc: "Struggling to find new RDP services? Well, 99RDP is set to offer you all the amazing perks alongside a 5% off on every new purchase.",
        btnLink: "https://99rdp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "KYGpd23",
    },
    {
        offText: "10% Off",
        rdpName: "AmazingRDP",
        cardTitle: "Perfect Beast Dedicated RDP $10 Off",
        verifyText: "Verified 4 Days Ago",
        usesText: "20 Uses Today",
        BoxDesc: "Get Flat $10 Off On Beast Dedicated Rdp AMD EPYC 7502P 32 Core 64 Threads Full Admin Access Location: Europe.",
        btnLink: "https://amazingrdp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "PDYvsvd23",
    },
    {
        offText: "30% Off",
        rdpName: "99Server",
        cardTitle: "Get 30% Off Each Time On GPU Dedicated Server.",
        verifyText: "Verified 2 Days Ago",
        usesText: "30 Uses Today",
        BoxDesc: "Want to renew RDP services? Now get a 30% off every time you seek a renewal.",
        btnLink: "https://99server.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "sjyKGT3",
    },
    {
        offText: "12% Off",
        rdpName: "99RDP",
        cardTitle: "Get 12% Off On All Quarterly plans.",
        verifyText: "Verified 4 Days Ago",
        usesText: "20 Uses Today",
        BoxDesc: "With a long term RDP plan, you can now save much more than before. Avail a 12% off on all quarterly plans.",
        btnLink: "https://99rdp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "KIFrts",
    },
    {
        offText: "15% Off",
        rdpName: "PCRDP",
        cardTitle: "15% Off on Residential RDP",
        verifyText: "Verified 2 Days Ago",
        usesText: "41 Uses Today",
        BoxDesc: "Did you expect RDP renewal at such decent rates? Instantly use this code for a 5% off on renewal.",
        btnLink: "https://pcrdp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "KIFrts",
    },
    {
        offText: "20% Off",
        rdpName: "AmazingRDP",
        cardTitle: "20% off on VPS Plans",
        verifyText: "Verified 4 Days Ago",
        usesText: "20 Uses Today",
        BoxDesc: "Get Flat 20% Off On All Quarterly VPS Plans. Use Code : SUMMERSALE Hurry! Offer Valid Till 20th August.",
        btnLink: "https://amazingrdp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "sKYfts3",
    },
    {
        offText: "10%",
        rdpName: "GPURDP",
        cardTitle: "Powerful GPU Dedicated Server. $10 off",
        verifyText: "Verified 8 Days Ago",
        usesText: "9 Uses Today",
        BoxDesc: "Powerful GPU Dedicated Server with GeForce® GTX 1080 configured so that you can run android emulators and online games smoothly.Get It At Just $159/m After Applying Coupon Code NVIDIA$10",
        btnLink: "https://gpurdp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "BGSSSFS",
    },
    {
        offText: "15%",
        rdpName: "OliveVPS",
        cardTitle: "Now Get 15% Off on All Monthly Plans.",
        verifyText: "Verified 7 Days Ago",
        usesText: "27 Uses Today",
        BoxDesc: "Want To Run Emulators? Want To Do Graphics Intensive Work? No Worries We Got It Covered For You.",
        btnLink: "https://olivevps.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "pajdsjbcfd",
    },
    {
        offText: "10%",
        rdpName: "HomeRDP",
        cardTitle: "Now Get 10% Off on All Monthly plans",
        verifyText: "Verified 4 Days Ago",
        usesText: "20 Uses Today",
        BoxDesc: "Planning on testing our RDP services by taking a monthly plan? Well, now you can get all monthly plans at 10%.",
        btnLink: "https://homerdp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "Nshsagds",
    },
    {
        offText: "20%",
        rdpName: "RDP Database",
        cardTitle: "Get Flat 20% Off On Hong Kong RDP Hurrry!!",
        verifyText: "Verified 4 Days Ago",
        usesText: "20 Uses Today",
        BoxDesc: "Hope This Year is Filled With Love, Laughter and Light Grab This One More Great Offer From RDP Database Get Flat 20% Off On Hong Kong RDP Hurrry!!",
        btnLink: "https://rdpdatabase.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "HGDbjsd",
    },
    {
        offText: "5%",
        rdpName: "EURRDP",
        cardTitle: "Get 5% Off Each Time On Every Renewal.",
        verifyText: "Verified 1 Days Ago",
        usesText: "71 Uses Today",
        BoxDesc: "Having taken first-hand experience of our RDP services, are you planning a renewal? Well, we have got a 5% off coupon code for you on every renewal.",
        btnLink: "https://eurdp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "LODJhbc",
    },
    {
        offText: "25%",
        rdpName: "OliveVPS",
        cardTitle: "Get 25% Off On All New purchases.",
        verifyText: "Verified 5 Days Ago",
        usesText: "46 Uses Today",
        BoxDesc: "Get an all-round year of quality RDP services at a whopping 25% off",
        btnLink: "https://olivevps.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "NBsbdhs",
    },
    {
        offText: "5%",
        rdpName: "99Server",
        cardTitle: "USA Dedicated Server $5 off",
        verifyText: "Verified 8 Days Ago",
        usesText: "23 Uses Today",
        BoxDesc: "Want To Run Emulators? Want To Do Graphics Intensive Work? No Worries We Got It Covered For You.",
        btnLink: "https://99server.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "Nhas656",
    },
    {
        offText: "30%",
        rdpName: "AmazingRDP",
        cardTitle: "30% Off amazing VPS Sale!!",
        verifyText: "Verified 4 Days Ago",
        usesText: "20 Uses Today",
        BoxDesc: "Get Flat 30% Off On All VPS Use Code : SUPERSALE21 Offer Valid Till 20th August",
        btnLink: "https://amazingrdp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "Mdhcbd928",
    },
    {
        offText: "20%",
        rdpName: "99Server",
        cardTitle: "Get 20% Off On Europe Dedicated Server.",
        verifyText: "Verified 4 Days Ago",
        usesText: "20 Uses Today",
        BoxDesc: "With a long term RDP plan, you can now save much more than before. Avail a 20% off on all quarterly plans.",
        btnLink: "https://99server.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "Manssah83",
    },
    {
        offText: "27%",
        rdpName: "RDP Database",
        cardTitle: "Powerful GPU Dedicated Server. $27 off",
        verifyText: "Verified 8 Days Ago",
        usesText: "30 Uses Today",
        BoxDesc: "Powerful GPU Dedicated Server with GeForce® GTX 1080 configured so that you can run android emulators and online games smoothly.Get It At Just $159/m After Applying Coupon Code L5K597t5i7",
        btnLink: "https://rdpdatabase.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "jsdhsbUHD",
    },
    {
        offText: "5%",
        rdpName: "GPURDP",
        cardTitle: "Affordable GPU Shared RDP $5 off",
        verifyText: "Verified 8 Days Ago",
        usesText: "7 Uses Today",
        BoxDesc: "Want To Run Emulators? Want To Do Graphics Intensive Work? No Worries We Got It Covered For You.",
        btnLink: "https://gpurdp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "Ljdfdh234",
    },
    {
        offText: "25%",
        rdpName: "99Server",
        cardTitle: "Get 25% Off Each Time On Netherlands Dedicated Server.",
        verifyText: "Verified 1 Days Ago",
        usesText: "71 Uses Today",
        BoxDesc: "Having taken first-hand experience of our RDP services, are you planning a renewal? Well, we have got a 25% off coupon code for you on every renewal.",
        btnLink: "https://99server.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "Manjdsdb",
    },
    {
        offText: "5%",
        rdpName: "HomeRDP",
        cardTitle: "Get 5% Off On All New purchases.",
        verifyText: "Verified 1 Days Ago",
        usesText: "71 Uses Today",
        BoxDesc: "Get authentic, transformational RDP services for your business now. Avail 5% off by using our coupon code. Offer applicable only for new users.",
        btnLink: "https://homerdp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "Kadhhf783",
    },
    {
        offText: "22% Off",
        rdpName: "PCRDP",
        cardTitle: "Now Get 22% Off Each Time On Every Renewal.",
        verifyText: "Verified 3 Days Ago",
        usesText: "55 Uses Today",
        BoxDesc: "Intending to renew services we offer? Now you can do it instantly with a tempting offer at hand. Get 22% off each time you get a renewal.",
        btnLink: "https://pcrdp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "Kdncdhs",
    },
    {
        offText: "30%",
        rdpName: "OliveVPS",
        cardTitle: "Get Flat 30% Off On Hong Kong RDP Hurrry!!",
        verifyText: "Verified 6 Days Ago",
        usesText: "27 Uses Today",
        BoxDesc: "With a long term RDP plan, you can now save much more than before. Avail a 30% off on all quarterly plans.",
        btnLink: "https://olivevps.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "Mksjd896",
    },
    {
        offText: "20%",
        rdpName: "AmazingRDP",
        cardTitle: "Get Flat 20% Off On Hong Kong RDP Hurrry!!",
        verifyText: "Verified 4 Days Ago",
        usesText: "20 Uses Today",
        BoxDesc: "Hope This Year is Filled With Love, Laughter and Light Grab This One More Great Offer From AmazingRdp Get Flat 20% Off On Hong Kong RDP Hurrry!!",
        btnLink: "https://amazingrdp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "Manxjhsc",
    },
    {
        offText: "20% Off",
        rdpName: "PCRDP",
        cardTitle: "Now Get 20% Off On All Quarterly plans.",
        verifyText: "Verified 1 Days Ago",
        usesText: "71 Uses Today",
        BoxDesc: "Take a prolonged plan and save some extra money. Get RDP quarterly plans at 20% off.",
        btnLink: "https://pcrdp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "nv976dfhv",
    },
    {
        offText: "12%",
        rdpName: "HomeRDP",
        cardTitle: "Get 12% Off On All Quarterly plans.",
        verifyText: "Verified 2 Days Ago",
        usesText: "11 Uses Today",
        BoxDesc: "Cover your quarterly needs by taking a quarterly plan at 12% off.",
        btnLink: "https://homerdp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "mnvdfhv",
    },
    {
        offText: "12% Off",
        rdpName: "GoRDP",
        cardTitle: "Get 12% Off On All Quarterly plans.",
        verifyText: "Verified 1 Days Ago",
        usesText: "71 Uses Today",
        BoxDesc: "Take a prolonged plan and save some extra money. Get RDP quarterly plans at 12% off.",
        btnLink: "https://gordp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "Mnsbhdf97",
    },
    {
        offText: "5%",
        rdpName: "EURRDP",
        cardTitle: "Get 5% Off On All New Purchase.",
        verifyText: "Verified 1 Days Ago",
        usesText: "71 Uses Today",
        BoxDesc: "Avail a 5% off on amazing RDP plans for new subscriptions.",
        btnLink: "https://eurdp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "nc54dcb",
    },
    {
        offText: "16%",
        rdpName: "RDP Database",
        cardTitle: "Get 16% Off On All New purchases.",
        verifyText: "Verified 1 Days Ago",
        usesText: "75 Uses Today",
        BoxDesc: "Get authentic, transformational RDP services for your business now. Avail 16% off by using our coupon code. Offer applicable only for new users.",
        btnLink: "https://rdpdatabase.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "Kshydtvb",
    },
    {
        offText: "5%",
        rdpName: "AmazingRDP",
        cardTitle: "5% off Renew your RDP/VPS NOW !!",
        verifyText: "Verified 4 Days Ago",
        usesText: "20 Uses Today",
        BoxDesc: "Use code AmazingR5 and Renew your RDP/VPS NOW !!",
        btnLink: "https://amazingrdp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "Lsjucdb64",
    },
    {
        offText: "12%",
        rdpName: "EURRDP",
        cardTitle: "Now Get 12% Off On All Quarterly plans.",
        verifyText: "Verified 1 Days Ago",
        usesText: "71 Uses Today",
        BoxDesc: "Take a prolonged plan and save some extra money. Get RDP quarterly plans at 12% off.",
        btnLink: "https://eurdp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "Pksijd73",
    },
    {
        offText: "25%",
        rdpName: "RDP Database",
        cardTitle: "Get 25% Off on All Annually plans.",
        verifyText: "Verified 3 Days Ago",
        usesText: "37 Uses Today",
        BoxDesc: "Running low on business’ yearly budget? Save more at the RDP front by taking a wholesome annual plan at 25% off.",
        btnLink: "https://rdpdatabase.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "Kshjsdbcb",
    },
    {
        offText: "35%",
        rdpName: "OliveVPS",
        cardTitle: "Powerful GPU Dedicated Server. $35 off",
        verifyText: "Verified 2 Days Ago",
        usesText: "20 Uses Today",
        BoxDesc: "Want to renew RDP services? Now get a 35% off every time you seek a renewal.",
        btnLink: "https://olivevps.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "djbfdhb6",
    },
    {
        offText: "20%",
        rdpName: "HomeRDP",
        cardTitle: "Get 20% Off on All Annually plans.",
        verifyText: "Verified 3 Days Ago",
        usesText: "17 Uses Today",
        BoxDesc: "Running low on business’ yearly budget? Save more at the RDP front by taking a wholesome annual plan at 20% off.",
        btnLink: "https://homerdp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "Kkbchd276",
    },
    {
        offText: "10% Off",
        rdpName: "PCRDP",
        cardTitle: "Get 10% Off On the Streaming Plan.",
        verifyText: "Verified 4 Days Ago",
        usesText: "300 Uses Today",
        BoxDesc: "To get great speed and guaranteed quality services, get streaming plans from PCRDP at 10% off.",
        btnLink: "https://pcrdp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "kjsugdv56",
    },
    {
        offText: "5%",
        rdpName: "HomeRDP",
        cardTitle: "Now Get 5% Off Each Time On Every Renewal.",
        verifyText: "Verified 3 Days Ago",
        usesText: "35 Uses Today",
        BoxDesc: "Intending to renew services we offer? Now you can do it instantly with a tempting offer at hand. Get 5% off each time you get a renewal.",
        btnLink: "https://homerdp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "lsjsc276",
    },
    {
        offText: "20% Off",
        rdpName: "GoRDP",
        cardTitle: "Now Get 20% Off on All Annually Plan.",
        verifyText: "Verified 31 Days Ago",
        usesText: "3 Uses Today",
        BoxDesc: "Get an all-round year of quality RDP services at a whopping 20% off.",
        btnLink: "https://gordp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "M76mdnfjdfb",
    },
    {
        offText: "20%",
        rdpName: "EURRDP",
        cardTitle: "Now Get 20% Off on All Annually Plan.",
        verifyText: "Verified 31 Days Ago",
        usesText: "3 Uses Today",
        BoxDesc: "Get an all-round year of quality RDP services at a whopping 20% off",
        btnLink: "https://eurdp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "Pkspjd3",
    },
    {
        offText: "5%",
        rdpName: "OliveVPS",
        cardTitle: "Get 5% Off Each Time On All Annually plans.",
        verifyText: "Verified 1 Days Ago",
        usesText: "41 Uses Today",
        BoxDesc: "Having taken first-hand experience of our RDP services, are you planning a renewal? Well, we have got a 5% off coupon code for you on every renewal.",
        btnLink: "https://olivevps.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "lkdsjbHT09",
    },
    {
        offText: "10%",
        rdpName: "RDP Database",
        cardTitle: "Now Get 10% Off on All Monthly Plans.",
        verifyText: "Verified 31 Days Ago",
        usesText: "70 Uses Today",
        BoxDesc: "Get an all-round year of quality RDP services at a whopping 10% off",
        btnLink: "https://rdpdatabase.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "askdhshs10",
    },
    {
        offText: "5% Off",
        rdpName: "ServerCafe",
        cardTitle: "USA Dedicated Server $5 off",
        verifyText: "Verified 8 Days Ago",
        usesText: "28 Uses Today",
        BoxDesc: "Customizable Dedicated Server Solutions for Your Unique Needs.",
        btnLink: "https://serverscafe.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "Tdafr976",
    },
    {
        offText: "10% Off",
        rdpName: "ServerCafe",
        cardTitle: "Now Get 10% Off on Mexico Dedicated Server.",
        verifyText: "Verified 18 Days Ago",
        usesText: "34 Uses Today",
        BoxDesc: "We offer dedicated server solutions tailored to meet your unique requirements and enhance your business operations.",
        btnLink: "https://serverscafe.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "Fjahki87",
    },
    {
        offText: "15% Off",
        rdpName: "ServerCafe",
        cardTitle: "Get 15% Off On Europe Dedicated Server.",
        verifyText: "Verified 4 Days Ago",
        usesText: "28 Uses Today",
        BoxDesc: "Customizable Server Options Choose from a range of processor, storage, and RAM options to build a server that meets your specific needs.",
        btnLink: "https://serverscafe.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "XKhsgd",
    },
    {
        offText: "20% Off",
        rdpName: "ServerCafe",
        cardTitle: "Get 20% Off Each Time On Netherlands Dedicated Server.",
        verifyText: "Verified 1 Days Ago",
        usesText: "71 Uses Today",
        BoxDesc: "Get High-Performance Hardware Our dedicated servers are built with the latest hardware to ensure maximum performance and reliability.",
        btnLink: "https://serverscafe.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "Hfagva",
    },
    {
        offText: "25% Off",
        rdpName: "ServerCafe",
        cardTitle: "Get 25% Off Each Time On GPU Dedicated Server.",
        verifyText: "Verified 2 Days Ago",
        usesText: "30 Uses Today",
        BoxDesc: "Get Scalable Server Solutions As your business grows, our dedicated servers can be easily scaled to meet your changing requirements.",
        btnLink: "https://serverscafe.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "Dafdayt",
    },
    {
        offText: "15% Off",
        rdpName: "serverscafe",
        cardTitle: "Now Get 15% Off on All Plans - Elevate Your Experience with Secure and Efficient RDPs!",
        verifyText: "Verified 1 Days Ago",
        usesText: "5 Uses Today",
        BoxDesc: "Experience the next level of productivity with our diverse range of Remote Desktop Plans. Unlock a 15% discount on all plans, ensuring secure and efficient remote access tailored to your needs. Elevate your digital journey and enjoy seamless connectivity today!",
        btnLink: "https://serverscafe.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "PLANSAVER15",
    },
    {
        offText: "15% Off",
        rdpName: "99RDP",
        cardTitle: "Now Get 15% Off on All Plans - Elevate Your Experience with Secure and Efficient RDPs!",
        verifyText: "Verified 1 Days Ago",
        usesText: "5 Uses Today",
        BoxDesc: "Experience the next level of productivity with our diverse range of Remote Desktop Plans. Unlock a 15% discount on all plans, ensuring secure and efficient remote access tailored to your needs. Elevate your digital journey and enjoy seamless connectivity today!",
        btnLink: "https://99rdp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "PLANSAVER15",
    },
    {
        offText: "15% Off",
        rdpName: "AmazingRDP",
        cardTitle: "Now Get 15% Off on All Plans - Elevate Your Experience with Secure and Efficient RDPs!",
        verifyText: "Verified 1 Days Ago",
        usesText: "5 Uses Today",
        BoxDesc: "Experience the next level of productivity with our diverse range of Remote Desktop Plans. Unlock a 15% discount on all plans, ensuring secure and efficient remote access tailored to your needs. Elevate your digital journey and enjoy seamless connectivity today!",
        btnLink: "https://amazingrdp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "PLANSAVER15",
    },
    {
        offText: "15% Off",
        rdpName: "EURRDP",
        cardTitle: "Now Get 15% Off on All Plans - Elevate Your Experience with Secure and Efficient RDPs!",
        verifyText: "Verified 1 Days Ago",
        usesText: "5 Uses Today",
        BoxDesc: "Experience the next level of productivity with our diverse range of Remote Desktop Plans. Unlock a 15% discount on all plans, ensuring secure and efficient remote access tailored to your needs. Elevate your digital journey and enjoy seamless connectivity today!",
        btnLink: "https://eurdp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "PLANSAVER15",
    },
    {
        offText: "15% Off",
        rdpName: "HomeRDP",
        cardTitle: "Now Get 15% Off on All Plans - Elevate Your Experience with Secure and Efficient RDPs!",
        verifyText: "Verified 1 Days Ago",
        usesText: "5 Uses Today",
        BoxDesc: "Experience the next level of productivity with our diverse range of Remote Desktop Plans. Unlock a 15% discount on all plans, ensuring secure and efficient remote access tailored to your needs. Elevate your digital journey and enjoy seamless connectivity today!",
        btnLink: "https://homerdp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "PLANSAVER15",
    },
    {
        offText: "15% Off",
        rdpName: "GPURDP",
        cardTitle: "Now Get 15% Off on All Plans - Elevate Your Experience with Secure and Efficient RDPs!",
        verifyText: "Verified 1 Days Ago",
        usesText: "5 Uses Today",
        BoxDesc: "Experience the next level of productivity with our diverse range of Remote Desktop Plans. Unlock a 15% discount on all plans, ensuring secure and efficient remote access tailored to your needs. Elevate your digital journey and enjoy seamless connectivity today!",
        btnLink: "https://gpurdp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "PLANSAVER15",
    },
    {
        offText: "15% Off",
        rdpName: "RDP Database",
        cardTitle: "Now Get 15% Off on All Plans - Elevate Your Experience with Secure and Efficient RDPs!",
        verifyText: "Verified 1 Days Ago",
        usesText: "5 Uses Today",
        BoxDesc: "Experience the next level of productivity with our diverse range of Remote Desktop Plans. Unlock a 15% discount on all plans, ensuring secure and efficient remote access tailored to your needs. Elevate your digital journey and enjoy seamless connectivity today!",
        btnLink: "https://rdpdatabase.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "PLANSAVER15",
    },
    {
        offText: "15% Off",
        rdpName: "PCRDP",
        cardTitle: "Now Get 15% Off on All Plans - Elevate Your Experience with Secure and Efficient RDPs!",
        verifyText: "Verified 1 Days Ago",
        usesText: "5 Uses Today",
        BoxDesc: "Experience the next level of productivity with our diverse range of Remote Desktop Plans. Unlock a 15% discount on all plans, ensuring secure and efficient remote access tailored to your needs. Elevate your digital journey and enjoy seamless connectivity today!",
        btnLink: "https://pcrdp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "PLANSAVER15",
    },
    {
        offText: "15% Off",
        rdpName: "GoRDP",
        cardTitle: "Now Get 15% Off on All Plans - Elevate Your Experience with Secure and Efficient RDPs!",
        verifyText: "Verified 1 Days Ago",
        usesText: "5 Uses Today",
        BoxDesc: "Experience the next level of productivity with our diverse range of Remote Desktop Plans. Unlock a 15% discount on all plans, ensuring secure and efficient remote access tailored to your needs. Elevate your digital journey and enjoy seamless connectivity today!",
        btnLink: "https://gordp.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "PLANSAVER15",
    },
    {
        offText: "15% Off",
        rdpName: "99server",
        cardTitle: "Now Get 15% Off on All Plans - Elevate Your Experience with Secure and Efficient RDPs!",
        verifyText: "Verified 1 Days Ago",
        usesText: "5 Uses Today",
        BoxDesc: "Experience the next level of productivity with our diverse range of Remote Desktop Plans. Unlock a 15% discount on all plans, ensuring secure and efficient remote access tailored to your needs. Elevate your digital journey and enjoy seamless connectivity today!",
        btnLink: "https://99server.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "PLANSAVER15",
    },
    {
        offText: "15% Off",
        rdpName: "olivevps",
        cardTitle: "Now Get 15% Off on All Plans - Elevate Your Experience with Secure and Efficient RDPs!",
        verifyText: "Verified 1 Days Ago",
        usesText: "5 Uses Today",
        BoxDesc: "Experience the next level of productivity with our diverse range of Remote Desktop Plans. Unlock a 15% discount on all plans, ensuring secure and efficient remote access tailored to your needs. Elevate your digital journey and enjoy seamless connectivity today!",
        btnLink: "https://olivevps.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "PLANSAVER15",
    },
    {
        offText: "15% Off",
        rdpName: "buyrdplive.com",
        cardTitle: "Now Get 15% Off on All Plans - Elevate Your Experience with Secure and Efficient RDPs!",
        verifyText: "Verified 1 Days Ago",
        usesText: "5 Uses Today",
        BoxDesc: "Experience the next level of productivity with our diverse range of Remote Desktop Plans. Unlock a 15% discount on all plans, ensuring secure and efficient remote access tailored to your needs. Elevate your digital journey and enjoy seamless connectivity today!",
        btnLink: "https://www.buyrdplive.com/",
        modalDesc: "Copy & paste the following code at checkout on",
        modalCode: "PLANSAVER15",
    }
]

export default DealsData